import { computed, ref } from 'vue'

const activeLayer = ref<string | null>(null)

export const useHeaderLayers = () => {
  const open = (layer: string) => { activeLayer.value = layer }
  const close = (layer: string) => { if (activeLayer.value === layer) { activeLayer.value = null } }
  const isOpen = (layer: string) => computed(() => activeLayer.value === layer)

  return { activeLayer, open, close, isOpen }
}
